import React from 'react';
import { useHistory } from 'react-router-dom';
import TranslationText from '../../../components/Translation/TranslationText';
import { ClappingHandsIcon } from '../../../icons/ClappingHandsIcon.jsx';

export function SmartIdWizardInfoPage(props) {
  const history = useHistory();

  const handleButtonClick = () => {
    if (props.buttonOnClick) {
      props.buttonOnClick();
    } else {
      history.push('/profileInformation');
    }
  };

  return (
    <div className="row row-center">       
      <div className="column-desktop-8 column-tablet-12 column-mobile-12 centered-content">
        <div className="smartid-info-vertical">
          <div className="icon">
            <ClappingHandsIcon />
          </div>    
          <div className="page-description-row">
            <p>
              <TranslationText text={props.message} />
            </p>
          </div>
          {props.buttonText && (
            <div className="smartid-info-btn-row">
              <button
                className="button button-primary"
                type="button"
                onClick={handleButtonClick}
              >
                <TranslationText text={props.buttonText} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>   
  );
}
